import { useTranslation } from '@cobliteam/i18n';
import Button from '@cobliteam/ui/components/Button';
import DatePicker from '@cobliteam/ui/components/DatePicker';
import Tag from '@cobliteam/ui/components/Tag';
import Icon from '@cobliteam/ui/icons';
import { SelectVehicle } from '@cobliteam/ui-business';
import type { PhotoFilters } from '../types';

interface FilterBarProps {
  filters: PhotoFilters;
  onFiltersChange: (next: PhotoFilters) => void;
  onRefresh: () => void;
  disabled?: boolean;
}

export const FilterBar = ({ filters, onFiltersChange, onRefresh, disabled }: FilterBarProps) => {
  const { t } = useTranslation('drivers');

  return (
    <div className='flex items-center gap-2'>
      <Button
        type='button'
        variant='outlined'
        color='default'
        size='sm'
        aria-label={t('face_id.selector.refresh')}
        onClick={onRefresh}
        disabled={disabled}
        icon={<Icon name='rotate-cw' />}
        className='shrink-0'
      />
      <DatePicker
        mode='range'
        max={7}
        selected={filters.dateRange}
        onSelect={(dateRange) => onFiltersChange({ ...filters, dateRange })}
        disabled={disabled}
        disabledDays={{ after: new Date() }}
        presets={['today', 'yesterday', 'last-7-days']}
        size='sm'
      />
      <SelectVehicle value={filters.vehicleId} onChange={(vehicle) => onFiltersChange({ ...filters, vehicleId: vehicle?.id })} disabled={disabled} className='shrink' portal />
      <Tag label={t('face_id.selector.filters.tip')} icon={<Icon name='lightbulb' color='primary' />} color='default' className='ml-auto max-w-fit flex-1' />
    </div>
  );
};

export default FilterBar;
